import * as Yup from 'yup';

import { IOptionItemProps } from '../../../../components/common/Select/Select';
import { getFormLocale } from '../../../../modules/form/const/formLocalization';
import EFormValidation from '../../../../modules/form/const/formValidation';
import { ICorporateFormTranslation } from '../../../../modules/internationalization/types/corporate';
import { EManageNumberRedirection } from './types';

/*
* -------------------------------------------
*          Form Validation
* -------------------------------------------
*/

export const getSimCardValidation = (
    translation: ICorporateFormTranslation['validation'],
    isAllowSimCardSuggest: boolean,
): Yup.AnySchema => {

    Yup.setLocale(getFormLocale(translation));

    return Yup.object()
        .shape({
            icc: Yup.object().shape({
                value: Yup.string().required().max(20),
                id: isAllowSimCardSuggest ? Yup.string().required() : Yup.string(),
            }),
        });
};

export const RedirectionAddTimeRequiredOption: string[] = [EManageNumberRedirection.noAnswer];

export const getRedirectionAddValidation = (translation: ICorporateFormTranslation['validation']): Yup.AnySchema => {

    Yup.setLocale(getFormLocale(translation));

    return Yup.object().shape({
        type: Yup.object().required(translation[EFormValidation.fieldRequired]),
        time: Yup.object().when('type', {
            is: (option?: IOptionItemProps) => option?.value
                && RedirectionAddTimeRequiredOption.includes(option.value.toString()),
            then: Yup.object().required(translation[EFormValidation.fieldRequired]),
        }),
        phone: Yup.string().required().min(10),
    });
};
